/* MR Sections — product list carousel, favourites, quick add */
(function () {
  'use strict';
  var WISH_KEY = 'mrh-wishlist';
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function getWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function setWish(w) { try { localStorage.setItem(WISH_KEY, JSON.stringify(w)); } catch (e) {} }
  function markWish(scope) {
    var w = getWish();
    $$('[data-mrh-wish]', scope).forEach(function (b) {
      var on = w.indexOf(b.dataset.mrhWish) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init(root) {
    if (!root || root._mrps) return;
    root._mrps = true;
    var host = root.querySelector('[data-mrps-carousel]');
    var track = root.querySelector('[data-mrps-track]');
    if (host && track) {
      var prev = root.querySelector('[data-mrps-prev]'), next = root.querySelector('[data-mrps-next]');
      var upd = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        host.classList.toggle('can-prev', track.scrollLeft > 2);
        host.classList.toggle('can-next', track.scrollLeft < max);
      };
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd, { passive: true });
      $$('img', track).forEach(function (im) { if (!im.complete) im.addEventListener('load', upd, { once: true }); });
      requestAnimationFrame(upd);
    }
    markWish(root);

    root.addEventListener('click', function (e) {
      var wish = e.target.closest('[data-mrh-wish]');
      if (wish) {
        e.preventDefault();
        var w = getWish(), h = wish.dataset.mrhWish, i = w.indexOf(h);
        if (i > -1) w.splice(i, 1); else w.push(h);
        setWish(w);
        $$('[data-mrps]').forEach(markWish);
        document.dispatchEvent(new CustomEvent('mrh:wishlist', { detail: { items: w } }));
        return;
      }
      var add = e.target.closest('[data-mrh-add]');
      if (add) {
        e.preventDefault();
        add.classList.add('is-loading');
        var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        fetch(base + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(add.dataset.mrhAdd, 10), quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            add.classList.remove('is-loading'); add.classList.add('is-added');
            setTimeout(function () { add.classList.remove('is-added'); }, 1600);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('mrh:cart-added', { detail: { variantId: add.dataset.mrhAdd } }));
          })
          .catch(function (err) {
            add.classList.remove('is-loading');
            alert((err && (err.description || err.message)) || 'Could not add to cart');
          });
      }
    });
  }

  function boot(scope) { $$('[data-mrps]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('mrh:wishlist', function () { $$('[data-mrps]').forEach(markWish); });
})();
